import { size } from "polished";
import styled, { css } from "styled-components";
import BaseNewIcon from "../../img/icons/new.svg?react";
import BaseSameIcon from "../../img/icons/same.svg?react";
import { isRTL } from "../../utils/locale";

const rtlStyles =
  isRTL() &&
  css`
    transform: scaleX(-1);
  `;

export const NewIcon = styled(BaseNewIcon)`
  ${size(12)}
  fill: ${({ theme }) => theme.colors.greyDarker3};
`;

export const SameIcon = styled(BaseSameIcon)`
  ${size(10)}
  fill: ${({ theme }) => theme.colors.white1};
  ${rtlStyles}
`;
